import BreadCrumb from 'Common/BreadCrumb';
import { BasicButton } from 'Common/Components';
import TableContainer from 'Common/TableContainer';
import { LucideDot } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useWarehouseList } from '../../hooks';
import DeleteModal from 'Common/DeleteModal';
import { ModalFormCreateWarehouse } from '../../components';
import { useWarehouseStore } from '../../store/useWarehouseStore';

export const WharehouseList = () => {
  const { t } = useTranslation();
  const { warehouseRows, columns, deleteToggle, deleteModal, onDeleteConfirm } =
    useWarehouseList();
   const {
      handleOpenModalWarehouse,
    } = useWarehouseStore();
    
  return (
    <>
      <div className='container-fluid group-data-[content=boxed]:max-w-boxed mx-auto'>
        <BreadCrumb
          title={t('CrudWarehouse.titleListPage')}
          pageTitle={t('menu.warehouse')}
        />
        <div className='card'>
          <div className='card-body'>
            <div className='flex w-full items-center justify-end flex-wrap'>
              <div className='mt-4'>
                <BasicButton onClick={() => {handleOpenModalWarehouse();}} type='button'>
                  <div className='flex flex-row justify-center items-center'>
                    <LucideDot size={16} color='#fff' />
                    <span className='ml-2 text-slate-50'>
                      {t('CrudWarehouse.addNewOptionBtn')}
                    </span>
                  </div>
                </BasicButton>
              </div>
            </div>
            <div className='w-full pt-6'>
              <TableContainer
                isPagination={true}
                columns={columns}
                data={warehouseRows}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName='my-2 col-span-12 overflow-x-auto lg:col-span-12'
                tableclassName='display stripe group dataTable w-full text-sm align-middle whitespace-nowrap'
                theadclassName='border-b border-slate-200 dark:border-zink-500'
                thclassName='ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc'
                tdclassName='p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500'
                PaginationClassName='flex flex-col items-center mt-5 md:flex-row'
              ></TableContainer>
            </div>
            <DeleteModal
              show={deleteModal}
              onHide={deleteToggle}
              onDelete={onDeleteConfirm}
            />
            <ModalFormCreateWarehouse></ModalFormCreateWarehouse>
          </div>
        </div>
      </div>
    </>
  );
};
